import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { privacyPoints } from "@/mocks/siteData";

export default function PrivacySection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative w-full aspect-square rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20protective%20shield%20formed%20from%20concentric%20translucent%20rings%20of%20light%20over%20deep%20teal%20darkness%2C%20warm%20amber%20glow%20at%20center%2C%20minimal%20editorial%20art%2C%20subtle%20grain%2C%20high%20contrast%2C%20negative%20space%2C%20no%20text%2C%20no%20people&width=1000&height=1000&seq=qs-privacy-a1&orientation=squarish"
                alt="同心光环构成的抽象护盾图形，象征潜声投稿对投稿者隐私与素材的保护"
                title="隐私保护 - 潜声投稿"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-foreground-950/90 to-transparent">
                <p className="font-heading text-2xl font-bold text-background-50">默认匿名</p>
                <p className="mt-1.5 text-sm text-background-200">
                  手机号与邮箱全部为选填，不填也能完成投稿。
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <SectionHeading
              eyebrow="隐私保护"
              title="我们把保护你，写进了流程里"
              desc="保护不是一句口号，而是具体到每一个环节的默认动作。以下六条，是我们处理任何一条线索都会遵守的原则。"
            />
          </Reveal>

          <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {privacyPoints.map((point, index) => (
              <Reveal key={point.id} delay={index * 60}>
                <div className="h-full p-5 rounded-lg bg-background-100 border border-background-200">
                  <div className="flex items-center gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-lg">
                      <i className={point.icon}></i>
                    </span>
                    <h3 className="m-0 font-heading text-base font-semibold text-foreground-950">
                      {point.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}